import { FtpService } from "../domainObjects/dataConnector";

export class DetectDelimiterRequest {
  path: string;
  isUseFtp:boolean;
  ftpService: FtpService;

    constructor(path: string,isUseFtp:boolean,ftpService: FtpService) {
      this.path = path;
      this.isUseFtp = isUseFtp;
      this.ftpService = ftpService;
    }
}